export const environment = {
  production: false,
  apiUrl: 'https://bitraze.biz/NEWBTRZPROMONTH/BTRZ',
  appName: 'Bitraze Biz',
  version: '1.0.0',
  socketUrl: '',
  imageUrl: '/uploads',
  reownProjectId: 'd6bdb70bbe4c0e608f175856e06cbbea',
};
